import { keycardUpsertModalRouteStore } from '../components/keycard-upsert-modal/domain/store';

import { getUniqueKeycardValue } from './index';

export default (data) => {
  if (!data) data = { label: '', value: '' };
  keycardUpsertModalRouteStore.setValue('userSelect', data);
  return getUniqueKeycardValue();
};
